import { body } from "@/text/contact";
import MenuPage from "../menu-page/menu-page";
import { useTranslation } from "react-i18next";

const CodeOfConduct = () => {
  const { t } = useTranslation("main");

  return (
    <MenuPage titles={[t("contact.headers.default")]}>
      <div className={"normal-case m-4 text-base font-comic"}>
        {body.content}
      </div>
    </MenuPage>
  );
};

export default CodeOfConduct;
